<script setup>
import OboardLogoLoader from '@/components/ui/SkeletonLoaders/OboardLogoLoader'

defineOptions({
  name: 'LoginAppLoader'
})
</script>

<template>
  <OboardLogoLoader class="la-Loader" />
</template>

<style scoped lang="scss">
.la-Loader {
  --height: 100vh;
  position: fixed;
  z-index: 0;
  width: 100%;
  left: 0;
  top: 0;
  pointer-events: none;
}
</style>
